module.exports = __webpack_public_path__ + "img/hero-1.d70fae6e.png";